import { useRef } from "react";

export interface PositionInfo {
	top: number;
	right: number;
}

/**
 * HTML `id` attribute to affix to the scroll container root. Originally this is affixed to the
 * `BigRichTextEditor`'s `div.text-editor`, but in theory it can be attached to anything.
 */
export const SCROLL_CONTAINER_ROOT_ID = "scroll-container-root";

/**
 * Props to attach to the Canvas's root "scroll container": the DOM element which `position:
 * absolute` elements (like some `compute_cell`s, the blue bar) are positioned relative to.
 */
export const useScrollContainerRootProps = () => {
	return { id: SCROLL_CONTAINER_ROOT_ID };
};

/**
 * Returns a React ref containing the root DOM element of the Canvas "scroll container": the DOM
 * element which `position: absolute` elements (like some `compute_cell`s, the blue bar) are
 * positioned relative to.
 */
export const useScrollContainerRootRef = () => {
	const scrollContainerRef = useRef(document.getElementById(SCROLL_CONTAINER_ROOT_ID));
	scrollContainerRef.current = document.getElementById(SCROLL_CONTAINER_ROOT_ID);

	return scrollContainerRef;
};
